<i-title styleClass="w-100" [text]="'courrierFiche.assignACircuit' | translate" [buttons]="titleButtons" level="1"></i-title>

<div class="modal-body mt-2 setOverflow">
  <div class="row" [formGroup]="form">
    <div class="col-md-12 mb-2">
      <span class="super-compos-label-input_no-block">{{ 'file' | translate }}:</span> {{ chosenFile.description }}
    </div>
    <div class="col-md-12 mb-2">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'courrierFiche.circuit' | translate }} *</span>
        <p-dropdown
          styleClass="w-100"
          [options]="listOfCircuits"
          [placeholder]="'courrierFiche.selectCircuit' | translate"
          appendTo="body"
          [virtualScroll]="true"
          [filter]="true"
          virtualScrollItemSize="30"
          (onChange)="changeCircuit($event)">
        </p-dropdown>
      </label>
    </div>
    <div class="col-md-6 mb-2">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'courrierFiche.dueDate' | translate }} *</span>
        <i-input [type]="'calendar'" [iInput]="{ options: { dateFormat: 'dd/mm/yy' } }" [control]="form.get('dateLimite')"> </i-input>
      </label>
    </div>
  </div>
  @if (listOfFilesFiltered.length > 0) {
    <div>
      <span class="super-compos-label-input">{{ 'courrierFiche.listAnnexFilesPDF' | translate }}</span>
      <i-table
        [columns]="columnsCircuits"
        [paginator]="false"
        [items]="listOfFilesFiltered"
        class="super-table"
        id="super-table-circuits-fiche-courrier"
        [multiselect]="true"
        height="calc(100vh - 350px)"
        (columnSelected)="onRowSelection($event)">
      </i-table>
    </div>
  } @else {
    <div class="alert alert-info mt-2">{{ 'courrierFiche.noFileAnnexPDFFound' | translate }}</div>
  }
  <ng-template #noFileAnnexPDFFound>
    <div class="alert alert-info mt-2">{{ 'courrierFiche.noFileAnnexPDFFound' | translate }}</div>
  </ng-template>
</div>
